//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {

    },
    data () {
        return {

        }
    },
    computed: {
        userInfo() {
            return this.$store.getters.user;
        },
        dwname() {
            return this.userInfo.dwname || '游客';
        },
        userHeaderText() {
            return this.dwname.slice(0, 1);
        },
        navDeopDownList() {
            return this.getGetters(`${this.getGetters('system').type}_navDropDown`)
        }
    },
    methods: {
        handleCommand(command) {
            command && command();
        }
    },
    mounted: function() {

    }
}
